import { isAuthenticated } from 'modules/common/permissions';

import DownloadPage from './entry';

export default [
  {
    path: '/download',
    component: DownloadPage,
    exact: true,
    permissions: [isAuthenticated],
  },
];
